// TODO: this lists of locale has been move to app-core to speed up modularization, but it should be in its own currency module

import { InjectionToken } from "@angular/core";

import { Country, Lang, Locale, LocaleCode, LocaleId } from "@hermes/locale";

export const LOCALE = new InjectionToken<Locale>("LOCALE");
export const LANG = new InjectionToken<Lang>("LANG");
export const COUNTRY = new InjectionToken<Country>("COUNTRY");

// list of ANGULAR LOCALES constants (ISO)
const DEAT: LocaleId = "de-AT";
const DECH: LocaleId = "de-CH";
const DE: LocaleId = "de";
const ENAE: LocaleId = "en-AE";
const ENAU: LocaleId = "en-AU";
const ENBE: LocaleId = "en-BE";
const ENCA: LocaleId = "en-CA";
const ENCN: LocaleId = "en-CN";
const ENCZ: LocaleId = "en-CZ";
const ENDK: LocaleId = "en-DK";
const ENFI: LocaleId = "en-FI";
const ENGB: LocaleId = "en-GB";
const ENHK: LocaleId = "en-HK";
const ENIE: LocaleId = "en-IE";
const ENMO: LocaleId = "en-MO";
const ENMY: LocaleId = "en-MY";
const ENNL: LocaleId = "en-NL";
const ENNO: LocaleId = "en-NO";
const ENPL: LocaleId = "en-PL";
const ENPT: LocaleId = "en-PT";
const ENSA: LocaleId = "en-SA";
const ENSE: LocaleId = "en-SE";
const ENSG: LocaleId = "en-SG";
const ENTH: LocaleId = "en-TH";
const ENGR: LocaleId = "en-GR";
const EN: LocaleId = "en";
const ESMX: LocaleId = "es-MX";
const ES: LocaleId = "es";
const FRBE: LocaleId = "fr-BE";
const FRCA: LocaleId = "fr-CA";
const FRCH: LocaleId = "fr-CH";
const FR: LocaleId = "fr";
const FRLU: LocaleId = "fr-LU";
const IT: LocaleId = "it";
const JA: LocaleId = "ja";
const KO: LocaleId = "ko";
const PT: LocaleId = "pt";
const ZHHANS: LocaleId = "zh-Hans";
const ZHHANT: LocaleId = "zh-Hant";

// list of CURRENCIES constants
const EUR = "EUR";
const GBP = "GBP";
const CAD = "CAD";
const CNY = "CNY";
const CHF = "CHF";
const DKK = "DKK";
const USD = "USD";
const SEK = "SEK";
const NOK = "NOK";
const CZK = "CZK";
const AUD = "AUD";
const JPY = "JPY";
const SGD = "SGD";
const MYR = "MYR";
const HKD = "HKD";
const MOP = "MOP";
const TWD = "TWD";
const KRW = "KRW";
const PLN = "PLN";
const AED = "AED";
const SAR = "SAR";
const THB = "THB";
const BRL = "BRL";
const MXN = "MXN";

export interface CurrencyConfiguration {
    symbol: string;
    format: string;
    thousandSeparator: string;
    code: string;
    decimalSeparator: string;
    precision?: number;
    localeId: LocaleId;
}

export const CURRENCY_MAP: Record<LocaleCode, CurrencyConfiguration> = {
    ae_en: {
        symbol: "AED",
        format: "%s %v",
        thousandSeparator: ",",
        code: AED,
        decimalSeparator: ".",
        localeId: ENAE,
    },
    fr_fr: {
        symbol: "€",
        format: "%v %s",
        thousandSeparator: " ",
        code: EUR,
        decimalSeparator: ",",
        localeId: FR,
    },
    be_fr: {
        symbol: "€",
        format: "%v %s",
        thousandSeparator: " ",
        code: EUR,
        decimalSeparator: ",",
        localeId: FRBE,
    },
    lu_fr: {
        symbol: "€",
        format: "%v %s",
        thousandSeparator: " ",
        code: EUR,
        decimalSeparator: ",",
        localeId: FRLU,
    },
    pt_en: {
        symbol: "€",
        format: "%s%v",
        thousandSeparator: ",",
        code: EUR,
        decimalSeparator: ".",
        localeId: ENPT,
    },
    pl_en: {
        symbol: "zł",
        format: "%s %v",
        thousandSeparator: ",",
        code: PLN,
        decimalSeparator: ".",
        localeId: ENPL,
    },
    gr_en: {
        symbol: "€",
        format: "%s%v",
        thousandSeparator: ",",
        code: EUR,
        decimalSeparator: ".",
        localeId: ENGR,
    },
    de_de: {
        symbol: "€",
        format: "%v %s",
        thousandSeparator: ".",
        code: EUR,
        decimalSeparator: ",",
        localeId: DE,
    },
    es_es: {
        symbol: "€",
        format: "%v %s",
        thousandSeparator: ".",
        code: EUR,
        decimalSeparator: ",",
        localeId: ES,
    },
    at_de: {
        symbol: "€",
        format: "%v %s",
        thousandSeparator: ".",
        code: EUR,
        decimalSeparator: ",",
        localeId: DEAT,
    },
    uk_en: {
        symbol: "£",
        format: "%s%v",
        thousandSeparator: ",",
        code: GBP,
        decimalSeparator: ".",
        localeId: ENGB,
    },
    // it_en: {symbol: "€", format: "%s %v", thousandSeparator: ".", code: EUR, decimalSeparator: ",", storeLocale: ENIT},"
    it_it: {
        symbol: "€",
        format: "%v %s",
        thousandSeparator: ".",
        code: EUR,
        decimalSeparator: ",",
        localeId: IT,
    },
    nl_en: {
        symbol: "€",
        format: "%s%v",
        thousandSeparator: ",",
        code: EUR,
        decimalSeparator: ".",
        localeId: ENNL,
    },
    be_en: {
        symbol: "€",
        format: "%s%v",
        thousandSeparator: ",",
        code: EUR,
        decimalSeparator: ".",
        localeId: ENBE,
    },
    ie_en: {
        symbol: "€",
        format: "%s%v",
        thousandSeparator: ",",
        code: EUR,
        decimalSeparator: ".",
        localeId: ENIE,
    },
    fi_en: {
        symbol: "€",
        format: "%s%v",
        thousandSeparator: ",",
        code: EUR,
        decimalSeparator: ".",
        localeId: ENFI,
    },
    ch_fr: {
        symbol: "CHF",
        format: "%v %s",
        thousandSeparator: " ",
        code: CHF,
        decimalSeparator: ",",
        localeId: FRCH,
    },
    ch_de: {
        symbol: "CHF",
        format: "%v %s",
        thousandSeparator: ".",
        code: CHF,
        decimalSeparator: ",",
        localeId: DECH,
    },
    dk_en: {
        symbol: "DKK",
        format: "%s%v",
        thousandSeparator: ",",
        code: DKK,
        decimalSeparator: ".",
        localeId: ENDK,
    },
    se_en: {
        symbol: "SEK",
        format: "%s%v",
        thousandSeparator: ",",
        code: SEK,
        decimalSeparator: ".",
        localeId: ENSE,
    },
    no_en: {
        symbol: "NOK",
        format: "%s%v",
        thousandSeparator: ",",
        code: NOK,
        decimalSeparator: ".",
        localeId: ENNO,
    },
    cz_en: {
        symbol: "CZK",
        format: "%s%v",
        thousandSeparator: ",",
        code: CZK,
        decimalSeparator: ".",
        localeId: ENCZ,
    },
    us_en: {
        symbol: "$",
        format: "%s%v",
        thousandSeparator: ",",
        code: USD,
        decimalSeparator: ".",
        localeId: EN,
    },
    ca_en: {
        symbol: "CA$",
        format: "%s%v",
        thousandSeparator: ",",
        code: CAD,
        decimalSeparator: ".",
        localeId: ENCA,
    },
    ca_fr: {
        symbol: "$CA",
        format: "%v %s",
        thousandSeparator: " ",
        code: CAD,
        decimalSeparator: ",",
        localeId: FRCA,
    },
    au_en: {
        symbol: "AU$",
        format: "%s%v",
        thousandSeparator: ",",
        code: AUD,
        decimalSeparator: ".",
        localeId: ENAU,
    },
    jp_ja: {
        symbol: "￥",
        format: "%s%v",
        thousandSeparator: ",",
        code: JPY,
        decimalSeparator: "",
        precision: 0,
        localeId: JA,
    },
    // jp_jp: {symbol: "¥", format: "%s%v", thousandSeparator: ",", code: JPY, decimalSeparator: "", precision: "0", localeId: JA},"
    cn_en: {
        symbol: "CN¥",
        format: "%s%v",
        thousandSeparator: ",",
        code: CNY,
        decimalSeparator: ".",
        localeId: ENCN,
    },
    cn_zh: {
        symbol: "¥",
        format: "%s%v",
        thousandSeparator: ",",
        code: CNY,
        decimalSeparator: ".",
        localeId: ZHHANS,
    },
    sg_en: {
        symbol: "S$",
        format: "%s %v",
        thousandSeparator: ",",
        code: SGD,
        decimalSeparator: ".",
        localeId: ENSG,
    },
    my_en: {
        symbol: "RM",
        format: "%s %v",
        thousandSeparator: ",",
        code: MYR,
        decimalSeparator: ".",
        localeId: ENMY,
    },
    hk_en: {
        symbol: "HKD",
        format: "%s %v",
        thousandSeparator: ",",
        code: HKD,
        decimalSeparator: ".",
        localeId: ENHK,
    },
    mo_en: {
        symbol: "MOP",
        format: "%s %v",
        thousandSeparator: ",",
        code: MOP,
        decimalSeparator: ".",
        localeId: ENMO,
    },
    // tw_en: {symbol: "NT$", format: "%s%v", thousandSeparator: ",", code: TWD, decimalSeparator: ".", storeLocale: "//},"
    kr_ko: {
        symbol: "₩",
        format: "%s %v",
        thousandSeparator: ",",
        code: KRW,
        decimalSeparator: ".",
        precision: 0,
        localeId: KO,
    },
    ri_en: {
        symbol: "SAR",
        format: "%s %v",
        thousandSeparator: ",",
        code: SAR,
        decimalSeparator: ".",
        localeId: ENSA,
    },
    sa_en: {
        symbol: "SAR",
        format: "%s %v",
        thousandSeparator: ",",
        code: SAR,
        decimalSeparator: ".",
        localeId: ENSA,
    },
    dh_en: {
        symbol: "AED",
        format: "%s %v",
        thousandSeparator: ",",
        code: AED,
        decimalSeparator: ".",
        localeId: ENAE,
    },
    th_en: {
        symbol: "฿",
        format: "%s %v",
        thousandSeparator: ",",
        code: THB,
        decimalSeparator: ".",
        localeId: ENTH,
    },
    tw_zh: {
        symbol: "NT$",
        format: "%s %v",
        thousandSeparator: ",",
        code: TWD,
        decimalSeparator: ".",
        localeId: ZHHANT,
    },
    br_pt: {
        symbol: "R$",
        format: "%s %v",
        thousandSeparator: ".",
        code: BRL,
        decimalSeparator: ",",
        localeId: PT,
    },
    mx_es: {
        symbol: "MXN$",
        format: "%s %v",
        thousandSeparator: ",",
        code: MXN,
        decimalSeparator: ".",
        localeId: ESMX,
    },
};
